import { IOrderItem } from '@/interfaces/order';
import dayjs from 'dayjs';
import { isNil } from 'lodash';

export interface IQRHeader {
  documentNo: string;
  supplierName: string;
  packingSize: number;
  producerName: string;
}

export interface IQRLotDetail {
  lotNo: string;
  productionDate: string;
  expireDate: string;
  quantity: number;
}

export interface IQRProductGroup {
  productCode: string;
  productName: string;
  packSize: number;
  lots: IQRLotDetail[];
}

/**
 * Format date as YYYYMMDD using dayjs
 */
function formatDate(dateStr: string): string {
  if (!dateStr || isNil(dateStr)) return '00000000';
  return dayjs(dateStr).format('YYYYMMDD');
}

/**
 * Group items by product code
 */
export function groupByProduct(
  items: Partial<IOrderItem>[],
): IQRProductGroup[] {
  const grouped: Record<string, IQRProductGroup> = {};

  for (const item of items) {
    if (!grouped[item.productCode as string]) {
      grouped[item.productCode as string] = {
        productCode: item.productCode as string,
        productName: item.productName as string,
        packSize: item.conversion as number,
        lots: [],
      };
    }

    grouped[item.productCode as string].lots.push({
      lotNo: item.lotNumber as string,
      productionDate: '00000000', // replace with real production date if available
      expireDate: formatDate(item.coaExpiredDate as string),
      quantity: item.quantity as number,
    });
  }

  return Object.values(grouped);
}

/**
 * Generate QR string from grouped product
 */
export function generateQRString(
  header: IQRHeader,
  product: IQRProductGroup,
): string {
  const lotString = product.lots
    .map(lot =>
      [
        lot.lotNo,
        lot.productionDate,
        lot.expireDate,
        lot.quantity.toString().padStart(5, '0'),
      ].join(','),
    )
    .join('|');

  const qrString = [
    header.documentNo,
    'Kemin',
    product.productName,
    header.packingSize.toString().padStart(5, '0'),
    lotString,
    'Kemin',
  ].join('(!)');

  return qrString;
}
